module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Light.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Light.woff
// module id = 78
// module chunks = 8